import { Injectable } from '@angular/core';
import { Company } from '../models/company/company.model';
import { MarketingTotal } from '../models/metrics/marketingTotal';

@Injectable()
export class MarketingTotalsFromCompaniesCalculator {

  calculate(companies: Company[]): MarketingTotal {

    const total = this.createMarketingTotalInitializedWithZero();

    companies.forEach(company => {
      total.totalLeads += company.marketingTotals.totalLeads;
      total.unassignedLeads += company.marketingTotals.unassignedLeads;
      total.newLeads += company.marketingTotals.newLeads;
      total.onTrackLeads += company.marketingTotals.onTrackLeads;
      total.expiredLeads += company.marketingTotals.expiredLeads;
      total.contactedLeads += company.marketingTotals.contactedLeads;
      total.totalVisits += company.marketingTotals.totalVisits;
      total.visitedLeads += company.marketingTotals.visitedLeads;
      total.closedLeads += company.marketingTotals.closedLeads;
      total.archivedLeads += company.marketingTotals.archivedLeads;
    });

    return total;
  }

  private createMarketingTotalInitializedWithZero() {
    const total = new MarketingTotal();

    total.totalLeads = 0;
    total.unassignedLeads = 0;
    total.newLeads = 0;
    total.onTrackLeads = 0;
    total.expiredLeads = 0;
    total.contactedLeads = 0;
    total.totalVisits = 0;
    total.visitedLeads = 0;
    total.closedLeads = 0;
    total.archivedLeads = 0;

    return total;
  }
}
